<template>
<div style="margin-top: 10px;text-align:left;padding: 5px;">
    <div :class="$style.menu">
        <div :class="[$style.tab, {[$style.selected]:view=='users'}, {'tab selected_tab':view=='users'}]" @click="setView('users')">{{ 'users' | str}}</div>
        <div v-if="this.$application.getUserType()==='superuser'" :class="[$style.tab, {[$style.selected]:view=='reports'}, {'tab selected_tab':view=='reports'}]" @click="setView('reports')">{{ 'manage_reports' | str}}</div>
        <div v-if="this.$application.getUserType()==='superuser'" :class="[$style.tab, {[$style.selected]:view=='retention'}, {'tab selected_tab':view=='retention'}]" @click="setView('retention')">{{ 'retention_policy' | str}}</div>
        <!-- <div :class="[$style.tab, {[$style.selected]:view=='groups'}]" @click="setView('groups')">Groups</div> -->
        <!-- <div :class="[$style.tab, {[$style.selected]:view=='dealers'}]" @click="setView('dealers')">Dealers</div> -->
        <!-- <div :class="[$style.tab, {[$style.selected]:view=='other'}]" @click="setView('other')">Other</div> -->
    </div>

    <div :class="$style.content">
        <component v-if="adminData && adminData.userAdmin" v-bind:is="view" :adminData="adminData" v-on:update_pool="update_pool"></component>
    </div> 

</div>
</template>

<script>
import api from '@/lib/ServerApi';
import users from '@/components/Admin/users.vue';
import reports from '@/components/Admin/reports.vue';
import retention from '@/components/Admin/retention.vue';
import groups from '@/components/Admin/groups.vue';
import dealers from '@/components/Admin/dealers.vue';
import other from '@/components/Admin/other.vue';

export default {
    name: 'admin',
    props: {

    },
    mounted: function(){
        this.init();
    },
    components: {
        users,
        reports,
        retention,
        groups,
        dealers,
        other        
    },
    data: function(){
        return {
            view: null,
            adminData: null
        }
    },
    methods: {
        init: function(){
            this.adminData = {
                userAdmin: null,
                dealerCodes: null
            }

            this.getUserAdminData();
            // this.getDealerCodes();
            this.view = 'users';
        },
		getUserAdminData: function(){
			api.getUserAdminData().then((response)=>{
				this.adminData.userAdmin = response;
			});
        },
		getDealerCodes: function(){
            api.getDealerCodes().then(response => {
                this.adminData.dealerCodes = response;
            });
		},        
        setView: function(view){
            this.view = view;
        },
        update_pool: function(value, type, operation){
            if(type == "user"){
                if(operation == "create") {
                    this.adminData.userAdmin.users.push(value);
                }
                console.log('update_pool',value)
            }
            else if(type == "report"){
                if(operation == "create"){
                    for(let i = 0; i<this.adminData.userAdmin.report_metadata.length-1; i++){
                        if(this.adminData.userAdmin.report_metadata[i].name.toLowerCase() < value.name.toLowerCase() && this.adminData.userAdmin.report_metadata[i+1].name.toLowerCase() > value.name.toLowerCase()){
                            this.adminData.userAdmin.report_metadata.splice(i+1,0,value);
                            break;
                        }
                    }
                }
                else if(operation == "delete"){
                    let index = this.adminData.userAdmin.report_metadata.findIndex(r => r.id == value.id);
                    this.adminData.userAdmin.report_metadata.splice(index, 1);
                }
            }
            // This callback gets run when the admin hits save. Can be used for additional on-save handling.
            
        }
    }
}
</script>

<style module>
.menu{
    position: relative;
    left: 0px;
    display: inline-block;
    vertical-align: top;
    width: 10%;
    margin-right: 12px;
    /* max-width: 85px; */
    /* border: 1px solid grey; */
    /*min-height: 200px;*/
    /*transform: translateX(-10px);*/
}
.tab{
    display: block;
    width: 100%;
    /*height: 20px;*/
    padding: 5px;
    border: 1px solid lightgrey;
    border-radius: 3px;
    /*border-top-right-radius: 3px;*/
    cursor: pointer;
    transition: 0.2s;
    font-size: 0.8em;
    text-align: center;
    color: black;
}
    .tab:hover{
        background-color: darkgrey;
        color: white;
        font-weight: bold;
    }

    .tab.selected{
        /* background-color: darkgrey; */
        color: white;
        font-weight: bold;
    }

.content{
    display: inline-block;
    vertical-align: top;
    border: 1px solid lightgrey;
    border-radius: 5px;
    width: 85%;
    min-height: 400px;
    padding: 15px;
}
</style>

<style lang="scss">
@import "@/_variables.scss";
.lexus .tab.selected_tab{
    background-color: $lexus;
}
.toyota .tab.selected_tab{
    background-color: $toyota;
}

</style>